export default {
  props: {
    /**
      * An icon used to represent the component instance
      */
    icon: {type: String, default: null}
  }
};
